function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#0082CA",
  fill: "#0082CA",
  cx: 12,
  cy: 12,
  r: 11.5
}), React.createElement("path", {
  d: "M9.776 15.99l8.129-8.128a.325.325 0 000-.46l-.307-.307a.325.325 0 00-.46 0l-7.592 7.592-2.684-2.684a.325.325 0 00-.46 0l-.307.307a.325.325 0 000 .46l3.221 3.22a.325.325 0 00.46 0z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgAtomsIconCheckCircleBiginline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgAtomsIconCheckCircleBiginline;